/**
 * Translation dictionary — French (default) + English.
 * Used via useT(key) hook.
 */

export const TRANSLATIONS = {
  fr: {
    nav: {
      home: "Accueil",
      menu: "La Carte",
      events: "Événements",
      gallery: "Galerie",
      giftcard: "Carte Cadeau",
      contact: "Contact",
      reserve: "Réserver",
    },
    topbar: {
      phone: "Réservez par téléphone",
    },
    footer: {
      tagline: "Restaurant français raffiné dans un hôtel particulier à Ville d'Avray. Cuisine maison, terrasse 240 m², réceptions privées.",
      sections: "Navigation",
      contact: "Contact",
      hours: "Horaires",
      legal: "Mentions",
      legalLinks: {
        mentions: "Mentions légales",
        privacy: "Politique de confidentialité",
        cookies: "Cookies",
        cgv: "CGV",
      },
      hoursValues: {
        monday: "Lundi · Fermé",
        tueSat: "Mardi — Samedi · 11h30-14h30 · 19h30-22h",
        sunday: "Dimanche · 11h30-14h30",
      },
      rights: "© L'Entracte. Tous droits réservés.",
      design: "Restaurant & Réception · Ville d'Avray",
    },
    home: {
      hero: {
        overline: "Restaurant & Réception · Ville d'Avray",
        title1: "L'art de la table,",
        title2: "à la française.",
        sub: "Une cuisine maison, créative et de saison, dans un hôtel particulier niché en plein cœur de Ville d'Avray. Terrasse fleurie de 240 m².",
        ctaReserve: "Réserver une table",
        ctaMenu: "Découvrir la carte",
      },
      band1: "Le Restaurant",
      about: {
        overline: "Notre maison",
        title: "Michel et son équipe vous accueillent dans un cadre",
        titleItalic: "idyllique",
        p1: "Installé dans un ancien hôtel particulier, L'Entracte dispose de deux espaces intérieurs à la décoration contemporaine et d'une magnifique terrasse de 240 m² surplombant un parc fleuri et arboré.",
        p2: "Notre cuisine, traditionnelle et créative, est exclusivement élaborée à base de produits frais et entièrement faite maison. Au fil des saisons, la carte évolue au gré des arrivages et de l'inspiration du chef.",
        stat1: "Terrasse",
        stat2: "Convives",
        stat3: "Fait maison",
        cta: "La Carte",
      },
      band2: "Évènementiel",
      events: {
        overline: "Réceptions privées",
        title: "Privatiser L'Entracte pour",
        titleItalic: "votre grand jour",
        p: "De 12 à 100 convives — mariages, anniversaires, baptêmes, séminaires : nous privatisons tout ou partie de l'établissement et construisons sur-mesure un menu adapté à votre projet.",
        types: ["Mariage", "Anniversaire", "Baptême", "Séminaire"],
        cta: "Demander un devis",
      },
      menuHighlights: {
        overline: "Menu Midi 33€ · du mardi au vendredi",
        title: "Une sélection de la carte",
        titleItalic: "au déjeuner",
        cta: "Voir toute la carte",
        loading: "Chargement de la carte…",
      },
      terrace: {
        overline: "La terrasse",
        title: "240 m² d'écrin de verdure pour vos déjeuners et dîners d'été.",
        cta: "Voir la galerie",
      },
      reviews: {
        overline: "Ils en parlent mieux que nous",
        title: "Les avis de nos clients",
      },
      giftStrip: {
        text: "Les fêtes de fin d'année approchent.",
        link: "Offrez une carte cadeau",
      },
      giftBanner: {
        overline: "Idée cadeau",
        title1: "Offrez",
        title2: "L'Entracte.",
        sub: "Une carte cadeau à offrir en quelques clics : reçue immédiatement par email, valable 1 an, au montant que vous choisissez.",
        bullet1: "Envoi immédiat par email",
        bullet2: "Valable 1 an",
        bullet3: "Montant libre",
        cta: "Offrir une carte cadeau",
        cardLabel: "Carte Cadeau",
        cardAmount: "Montant au choix",
        cardFoot: "Valable 1 an · Ville-d'Avray",
      },
      finalCta: {
        overline: "Une table vous attend",
        title1: "L'Entracte",
        title2: ", votre prochaine adresse.",
        reserve: "Réserver",
        contact: "Nous contacter",
      },
    },
    menu: {
      overline: "La maison",
      title: "La Carte",
      sub: "Une cuisine française entièrement faite maison, élaborée à partir de produits frais et de saison. Notre carte évolue au fil des arrivages.",
      lunchBanner: "Menu Midi 33€ · Entrée + Plat ou Plat + Dessert au choix parmi les plats annotés d'une étoile (du mardi au vendredi hors jours fériés).",
      loading: "Chargement de la carte…",
      section: "Section",
      allergens: "Allergènes",
      legend: {
        star: "Inclus dans le Menu Midi 33€",
        veg: "Végétarien",
        spicy: "Épicé",
      },
    },
    reservation: {
      overline: "Votre table",
      title: "Réservation",
      sub: "Réservez votre table en quelques clics ci-dessous via notre partenaire Zenchef. Pour toute demande spécifique (groupe, allergie, événement), contactez-nous directement par téléphone.",
      privacyNote: "Le système de réservation est fourni par Zenchef. Vos données restent confidentielles.",
      byPhone: "Par téléphone",
      hours: "Du mardi au samedi",
      info: "Informations",
      hoursTitle: "Horaires",
      hoursList: [
        ["Lundi", "Fermé"],
        ["Mardi — Samedi", "11h30-14h30 · 19h30-22h"],
        ["Dimanche", "11h30-14h30"],
      ],
    },
    gallery: {
      overline: "Notre univers",
      title: "Galerie",
      sub: "Le restaurant, sa terrasse, ses plats, ses moments. Un aperçu de l'expérience L'Entracte.",
      tabs: { all: "Tout", interieur: "Intérieur", terrasse: "Terrasse", plats: "Plats", evenements: "Événements" },
    },
    events: {
      overline: "Réceptions privées",
      title1: "Vos événements,",
      title2: "d'exception.",
      sub: "L'Entracte est le lieu idéal pour l'organisation de vos événements privés et professionnels de 12 à 100 convives. Privatisez l'ensemble ou une partie de l'établissement pour votre grand jour.",
      bullets: [
        "Privatisation totale ou partielle (12 à 100 personnes)",
        "Menus sur-mesure conçus avec le chef",
        "Sélection de vins, coordination du service",
        "Aménagement scénographique de la salle et de la terrasse",
      ],
      formOverline: "Demande de devis",
      formTitle: "Parlons de votre projet",
      successTitle: "Merci !",
      successBody: "Votre demande nous est bien parvenue. Nous reviendrons vers vous sous 48h.",
      fields: {
        name: "Nom complet *",
        email: "Email *",
        phone: "Téléphone",
        date: "Date",
        guests: "Nombre de convives",
        message: "Votre message",
      },
      types: ["Mariage", "Anniversaire", "Baptême", "Séminaire", "Cocktail", "Autre"],
      submit: "Envoyer ma demande",
      sending: "Envoi…",
      thanks: {
        overline: "Demande envoyée",
        title1: "Merci pour",
        title2: "votre demande.",
        body: "Votre demande de devis a bien été reçue. Notre équipe revient vers vous sous 48 heures avec une proposition sur-mesure adaptée à votre projet.",
        checkEmail: "Un email de confirmation vient de vous être envoyé — pensez à vérifier vos spams.",
        backHome: "Retour à l'accueil",
        seeMenu: "Découvrir la carte",
      },
    },
    contact: {
      overline: "Nous écrire",
      title: "Contact",
      sub: "Une question, une suggestion, une demande particulière ? Nous prenons le temps de vous répondre personnellement.",
      address: "Adresse",
      phone: "Téléphone",
      email: "Email",
      hours: "Horaires",
      hoursValue: "Mardi — Samedi · 11h30-14h30 et 19h30-22h",
      hoursSunday: "Dimanche · 11h30-14h30 (déjeuner)",
      formOverline: "Formulaire",
      formTitle: "Écrivez-nous",
      fields: { name: "Nom *", email: "Email *", phone: "Téléphone", subject: "Objet", message: "Votre message *" },
      submit: "Envoyer",
      sending: "Envoi…",
      success: "Message envoyé",
      successBody: "Merci ! Nous reviendrons vers vous rapidement.",
      mapOpen: "Ouvrir dans Google Maps",
      thanks: {
        overline: "Message envoyé",
        title1: "Merci pour votre",
        title2: "message.",
        body: "Nous avons bien reçu votre message et vous répondrons personnellement dans les meilleurs délais.",
        checkEmail: "Un email de confirmation vient de vous être envoyé — pensez à vérifier vos spams.",
        backHome: "Retour à l'accueil",
        reserve: "Réserver une table",
      },
    },
    giftcard: {
      overline: "Offrez l'exception",
      title1: "Carte",
      title2: "Cadeau.",
      sub: "Offrez un moment d'exception à ceux qui vous sont chers. Une carte cadeau L'Entracte, c'est la promesse d'un dîner gastronomique dans un cadre raffiné, au cœur d'un hôtel particulier de Ville d'Avray.",
      bullets: [
        "Carte cadeau envoyée immédiatement par email (PDF)",
        "Valable 1 an, utilisable en une ou plusieurs fois",
        "Personnalisez avec un message dédié",
        "Paiement sécurisé par Stripe",
      ],
      securePayment: "Paiement sécurisé · CB, Apple Pay, Google Pay",
      formTitle: "Composer votre carte",
      amount: "Montant",
      other: "Autre",
      customPlaceholder: "Saisir un montant",
      customHint: "Montant libre entre",
      beneficiary: "Bénéficiaire",
      beneficiaryName: "Nom du bénéficiaire *",
      messagePlaceholder: "Message personnel (optionnel) — apparaîtra sur la carte",
      yourInfo: "Vos coordonnées",
      yourName: "Votre nom *",
      yourEmail: "Votre email *",
      sendDirectly: "Envoyer la carte cadeau",
      sendDirectlyB: "directement au bénéficiaire",
      sendDirectlyHint: "Vous recevrez également une copie de confirmation.",
      beneficiaryEmail: "Email du bénéficiaire *",
      totalToPay: "Total à payer",
      payCta: "Payer & recevoir la carte",
      redirecting: "Redirection…",
      terms: "En procédant au paiement, vous acceptez nos conditions : carte valable 1 an, non remboursable, utilisable sur réservation au 01 82 00 18 67.",
      errorRange: "Le montant doit être compris entre",
      errorBenefEmail: "Email du bénéficiaire requis pour un envoi direct.",
    },
    giftcardSuccess: {
      checking: "Vérification du paiement",
      checkingTitle: "Un instant…",
      checkingSub: "Nous confirmons votre paiement auprès de Stripe.",
      success: "Paiement confirmé",
      thanks: "Merci !",
      ready: "Votre carte est prête.",
      forBenef: "La carte cadeau pour",
      hasBeen: "a bien été générée.",
      generic: "Votre carte cadeau a bien été générée.",
      yourCode: "Code de votre carte",
      keepCode: "Conservez ce code, il sera demandé lors de votre visite.",
      emailSent: "Un email avec la carte en PDF vient d'être envoyé.",
      emailComing: "L'email avec la carte va vous parvenir d'ici quelques minutes.",
      backHome: "Retour à l'accueil",
      reserveTable: "Réserver une table",
      processing: "Paiement en cours de traitement",
      stillFew: "Plus que quelques instants",
      stillBody: "Votre paiement met un peu plus de temps à être confirmé. Vous recevrez votre carte cadeau par email dès la validation.",
      errorTitle: "Paiement non finalisé",
      errorH1: "Un souci est survenu",
      errorBody: "Votre paiement n'a pas pu être finalisé ou a été annulé. Aucun débit n'a été effectué.",
      retry: "Réessayer",
      contactUs: "Nous contacter",
    },
    cookies: {
      title: "Cookies & vie privée",
      body: "Nous utilisons des cookies pour mesurer l'audience du site et améliorer votre expérience. Vous pouvez accepter ou refuser les cookies non essentiels.",
      more: "En savoir plus",
      policy: "Politique de confidentialité",
      accept: "Tout accepter",
      refuse: "Tout refuser",
    },
    langSwitch: { label: "Langue", fr: "Français", en: "English" },
  },

  en: {
    nav: {
      home: "Home",
      menu: "Menu",
      events: "Events",
      gallery: "Gallery",
      giftcard: "Gift Card",
      contact: "Contact",
      reserve: "Book",
    },
    topbar: {
      phone: "Book by phone",
    },
    footer: {
      tagline: "Refined French restaurant set in a private townhouse in Ville d'Avray. House-made cuisine, 240 m² terrace, private events.",
      sections: "Navigation",
      contact: "Contact",
      hours: "Opening Hours",
      legal: "Legal",
      legalLinks: {
        mentions: "Legal notice",
        privacy: "Privacy policy",
        cookies: "Cookies",
        cgv: "Terms",
      },
      hoursValues: {
        monday: "Monday · Closed",
        tueSat: "Tuesday — Saturday · 11:30-14:30 · 19:30-22:00",
        sunday: "Sunday · 11:30-14:30",
      },
      rights: "© L'Entracte. All rights reserved.",
      design: "Restaurant & Reception · Ville d'Avray",
    },
    home: {
      hero: {
        overline: "Restaurant & Reception · Ville d'Avray",
        title1: "The art of dining,",
        title2: "à la française.",
        sub: "House-made, creative, seasonal cuisine inside a private townhouse in the heart of Ville d'Avray. Lush 240 m² garden terrace.",
        ctaReserve: "Book a table",
        ctaMenu: "Discover the menu",
      },
      band1: "The Restaurant",
      about: {
        overline: "Our house",
        title: "Michel and his team welcome you in an",
        titleItalic: "idyllic setting",
        p1: "Set in a former private townhouse, L'Entracte offers two contemporary indoor dining rooms and a magnificent 240 m² terrace overlooking a flowered, wooded park.",
        p2: "Our traditional yet creative cuisine is crafted exclusively from fresh produce, entirely house-made. The menu evolves with the seasons, the deliveries, and the chef's inspiration.",
        stat1: "Terrace",
        stat2: "Guests",
        stat3: "House-made",
        cta: "The Menu",
      },
      band2: "Events",
      events: {
        overline: "Private events",
        title: "Reserve L'Entracte for",
        titleItalic: "your big day",
        p: "From 12 to 100 guests — weddings, birthdays, christenings, corporate seminars: we privatise all or part of the venue and craft a bespoke menu tailored to your project.",
        types: ["Wedding", "Birthday", "Christening", "Seminar"],
        cta: "Request a quote",
      },
      menuHighlights: {
        overline: "Lunch Menu €33 · Tue-Fri",
        title: "A selection from the menu",
        titleItalic: "at lunchtime",
        cta: "See the full menu",
        loading: "Loading the menu…",
      },
      terrace: {
        overline: "The terrace",
        title: "240 m² of lush greenery for your summer lunches and dinners.",
        cta: "View the gallery",
      },
      reviews: {
        overline: "Hear it from our guests",
        title: "What our customers say",
      },
      giftStrip: {
        text: "The festive season is coming.",
        link: "Give a gift card",
      },
      giftBanner: {
        overline: "Gift idea",
        title1: "Give",
        title2: "L'Entracte.",
        sub: "A gift card in just a few clicks: delivered instantly by email, valid for one year, for the amount of your choice.",
        bullet1: "Instant email delivery",
        bullet2: "Valid 1 year",
        bullet3: "Any amount",
        cta: "Offer a gift card",
        cardLabel: "Gift Card",
        cardAmount: "Amount of your choice",
        cardFoot: "Valid 1 year · Ville-d'Avray",
      },
      finalCta: {
        overline: "A table awaits you",
        title1: "L'Entracte",
        title2: ", your next address.",
        reserve: "Book",
        contact: "Contact us",
      },
    },
    menu: {
      overline: "The house",
      title: "The Menu",
      sub: "Entirely house-made French cuisine crafted from fresh, seasonal produce. Our menu evolves with the deliveries.",
      lunchBanner: "Lunch Menu €33 · Starter + Main or Main + Dessert from the dishes marked with a star (Tuesday to Friday, excluding public holidays).",
      loading: "Loading the menu…",
      section: "Section",
      allergens: "Allergens",
      legend: {
        star: "Included in the €33 Lunch Menu",
        veg: "Vegetarian",
        spicy: "Spicy",
      },
    },
    reservation: {
      overline: "Your table",
      title: "Reservation",
      sub: "Book your table in just a few clicks below via our partner Zenchef. For specific requests (group, allergy, event), please call us directly.",
      privacyNote: "Reservations are powered by Zenchef. Your data remains confidential.",
      byPhone: "By phone",
      hours: "Tuesday to Saturday",
      info: "Information",
      hoursTitle: "Opening hours",
      hoursList: [
        ["Monday", "Closed"],
        ["Tuesday — Saturday", "11:30-14:30 · 19:30-22:00"],
        ["Sunday", "11:30-14:30"],
      ],
    },
    gallery: {
      overline: "Our world",
      title: "Gallery",
      sub: "The restaurant, its terrace, its dishes, its moments. A glimpse of the L'Entracte experience.",
      tabs: { all: "All", interieur: "Interior", terrasse: "Terrace", plats: "Dishes", evenements: "Events" },
    },
    events: {
      overline: "Private events",
      title1: "Your events,",
      title2: "exceptional.",
      sub: "L'Entracte is the ideal venue for your private and professional events from 12 to 100 guests. Privatise all or part of the establishment for your big day.",
      bullets: [
        "Full or partial venue hire (12 to 100 people)",
        "Bespoke menus crafted with the chef",
        "Wine selection, service coordination",
        "Custom layout of the dining room and terrace",
      ],
      formOverline: "Quote request",
      formTitle: "Let's discuss your project",
      successTitle: "Thank you!",
      successBody: "Your request has been received. We will get back to you within 48 hours.",
      fields: {
        name: "Full name *",
        email: "Email *",
        phone: "Phone",
        date: "Date",
        guests: "Number of guests",
        message: "Your message",
      },
      types: ["Wedding", "Birthday", "Christening", "Seminar", "Cocktail", "Other"],
      submit: "Send my request",
      sending: "Sending…",
      thanks: {
        overline: "Request sent",
        title1: "Thank you for",
        title2: "your request.",
        body: "Your quote request has been received. Our team will get back to you within 48 hours with a bespoke proposal tailored to your project.",
        checkEmail: "A confirmation email has just been sent to you — please check your spam folder.",
        backHome: "Back to home",
        seeMenu: "Discover the menu",
      },
    },
    contact: {
      overline: "Get in touch",
      title: "Contact",
      sub: "A question, a suggestion, a special request? We take the time to respond to you personally.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Opening hours",
      hoursValue: "Tuesday — Saturday · 11:30-14:30 and 19:30-22:00",
      hoursSunday: "Sunday · 11:30-14:30 (lunch only)",
      formOverline: "Form",
      formTitle: "Write to us",
      fields: { name: "Name *", email: "Email *", phone: "Phone", subject: "Subject", message: "Your message *" },
      submit: "Send",
      sending: "Sending…",
      success: "Message sent",
      successBody: "Thank you! We will get back to you shortly.",
      mapOpen: "Open in Google Maps",
      thanks: {
        overline: "Message sent",
        title1: "Thank you for",
        title2: "your message.",
        body: "We have received your message and will get back to you personally as soon as possible.",
        checkEmail: "A confirmation email has just been sent to you — please check your spam folder.",
        backHome: "Back to home",
        reserve: "Book a table",
      },
    },
    giftcard: {
      overline: "Offer the exceptional",
      title1: "Gift",
      title2: "Card.",
      sub: "Offer an exceptional moment to those dear to you. An L'Entracte gift card is the promise of a fine-dining experience in an elegant setting, in the heart of a Ville d'Avray private townhouse.",
      bullets: [
        "Gift card sent instantly by email (PDF)",
        "Valid 1 year, usable in one or several visits",
        "Personalise with a dedicated message",
        "Secure payment via Stripe",
      ],
      securePayment: "Secure payment · Card, Apple Pay, Google Pay",
      formTitle: "Design your card",
      amount: "Amount",
      other: "Other",
      customPlaceholder: "Enter an amount",
      customHint: "Free amount between",
      beneficiary: "Recipient",
      beneficiaryName: "Recipient name *",
      messagePlaceholder: "Personal message (optional) — will appear on the card",
      yourInfo: "Your details",
      yourName: "Your name *",
      yourEmail: "Your email *",
      sendDirectly: "Send the gift card",
      sendDirectlyB: "directly to the recipient",
      sendDirectlyHint: "You will also receive a confirmation copy.",
      beneficiaryEmail: "Recipient email *",
      totalToPay: "Total to pay",
      payCta: "Pay & receive the card",
      redirecting: "Redirecting…",
      terms: "By proceeding, you accept our terms: card valid 1 year, non-refundable, usable upon reservation at +33 1 82 00 18 67.",
      errorRange: "The amount must be between",
      errorBenefEmail: "Recipient email required for a direct delivery.",
    },
    giftcardSuccess: {
      checking: "Verifying payment",
      checkingTitle: "One moment…",
      checkingSub: "We are confirming your payment with Stripe.",
      success: "Payment confirmed",
      thanks: "Thank you!",
      ready: "Your card is ready.",
      forBenef: "The gift card for",
      hasBeen: "has been successfully generated.",
      generic: "Your gift card has been successfully generated.",
      yourCode: "Your card code",
      keepCode: "Keep this code safe — it will be requested during your visit.",
      emailSent: "An email with the PDF card has just been sent.",
      emailComing: "The email with the card will reach you within a few minutes.",
      backHome: "Back to home",
      reserveTable: "Book a table",
      processing: "Payment processing",
      stillFew: "Just a few more moments",
      stillBody: "Your payment is taking a little longer to confirm. You will receive your gift card by email as soon as it is validated.",
      errorTitle: "Payment not finalised",
      errorH1: "Something went wrong",
      errorBody: "Your payment could not be finalised or was cancelled. No charge has been made.",
      retry: "Try again",
      contactUs: "Contact us",
    },
    cookies: {
      title: "Cookies & privacy",
      body: "We use cookies to measure site audience and improve your experience. You can accept or refuse non-essential cookies.",
      more: "Learn more",
      policy: "Privacy policy",
      accept: "Accept all",
      refuse: "Refuse all",
    },
    langSwitch: { label: "Language", fr: "Français", en: "English" },
  },
};
